<div *ngIf="editForm" class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationpartybccbsa.header' | translate }}</span>
        </h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big" style="width: 50%">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationpartybccbsa.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <input name="label" type="text" formControlName="label" class="ir-form-set" />
            </td>
          </tr>
          <tr>
            <td class="margin-big" style="width: 50%">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationpartybccbsa.done-by' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <div style="display: inline-block" (click)="changeCheckboxValue(editForm.controls.bobstBsf)">
                  <i class="material-icons" style="vertical-align: top" *ngIf="!editForm.controls.bobstBsf.value"
                    >check_box_outline_blank</i
                  >
                  <i
                    class="material-icons important"
                    style="vertical-align: top"
                    *ngIf="editForm.controls.bobstBsf.value"
                    >check_box</i
                  >
                  <span>{{ 'plugins.installationpartybccbsa.bobst-bsf' | translate }}</span>
                </div>
                <div
                  style="display: inline-block; margin-left: 15px"
                  (click)="changeCheckboxValue(editForm.controls.bobstBcc)"
                >
                  <i class="material-icons" style="vertical-align: top" *ngIf="!editForm.controls.bobstBcc.value"
                    >check_box_outline_blank</i
                  >
                  <i
                    class="material-icons important"
                    style="vertical-align: top"
                    *ngIf="editForm.controls.bobstBcc.value"
                    >check_box</i
                  >
                  <span>{{ 'plugins.installationpartybccbsa.bobst-bcc' | translate }}</span>
                </div>
                <div
                  style="display: inline-block; margin-left: 15px"
                  (click)="changeCheckboxValue(editForm.controls.bobstAgent)"
                >
                  <i class="material-icons" style="vertical-align: top" *ngIf="!editForm.controls.bobstAgent.value"
                    >check_box_outline_blank</i
                  >
                  <i
                    class="material-icons important"
                    style="vertical-align: top"
                    *ngIf="editForm.controls.bobstAgent.value"
                    >check_box</i
                  >
                  <span>{{ 'plugins.installationpartybccbsa.bobst-agent' | translate }} </span>
                </div>
                <div
                  style="display: inline-block; margin-left: 15px"
                  (click)="changeCheckboxValue(editForm.controls.customer)"
                >
                  <i class="material-icons" style="vertical-align: top" *ngIf="!editForm.controls.customer.value"
                    >check_box_outline_blank</i
                  >
                  <i
                    class="material-icons important"
                    style="vertical-align: top"
                    *ngIf="editForm.controls.customer.value"
                    >check_box</i
                  >
                  <span>{{ 'plugins.installationpartybccbsa.customer' | translate }}</span>
                </div>
                <div
                  style="display: inline-block; margin-left: 15px"
                  (click)="changeCheckboxValue(editForm.controls.thirdParty)"
                >
                  <i class="material-icons" style="vertical-align: top" *ngIf="!editForm.controls.thirdParty.value"
                    >check_box_outline_blank</i
                  >
                  <i
                    class="material-icons important"
                    style="vertical-align: top"
                    *ngIf="editForm.controls.thirdParty.value"
                    >check_box</i
                  >
                  <span>{{ 'plugins.installationpartybccbsa.third-party' | translate }}</span>
                </div>
                <div
                  style="display: inline-block; margin-left: 15px"
                  (click)="changeCheckboxValue(editForm.controls.na)"
                >
                  <i class="material-icons" style="vertical-align: top" *ngIf="!editForm.controls.na.value"
                    >check_box_outline_blank</i
                  >
                  <i class="material-icons important" style="vertical-align: top" *ngIf="editForm.controls.na.value"
                    >check_box</i
                  >
                  <span>{{ 'plugins.installationpartybccbsa.non-applicable' | translate }}</span>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
